import Vapi from 'vuex-rest-api';

const fetcherAdminListItem = new Vapi({
  state: {
    fetcherAdminListItem: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminListItem',
    property: 'fetcherAdminListItem',
    path: ({ liid }) => `/api/fetcher/admin/listItems/${liid}`,
  })
  .getStore();

export default fetcherAdminListItem;
